import { render } from "./LoginGm.vue?vue&type=template&id=06c25811&scoped=true"
import script from "./LoginGm.vue?vue&type=script&lang=js"
export * from "./LoginGm.vue?vue&type=script&lang=js"

import "./LoginGm.vue?vue&type=style&index=0&id=06c25811&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c25811"]])

export default __exports__